// src/hooks/transportations/useGetTransportations.js
import { useQuery } from "@tanstack/react-query";
import { getAllTransportations } from "../../api/apiTransportations";
import i18next from "i18next";

const QUERY_KEY = ["transportations"];

const useGetTransportations = (page = 1, perPage = 15, filters = {}) => {
    const {
        data,
        isLoading,
        isError,
        error,
    } = useQuery({
        queryKey: [...QUERY_KEY, page, perPage, filters, i18next.language],
        queryFn: () => getAllTransportations(page, perPage, filters),
        keepPreviousData: true,
    });

    return {
        isLoading,
        error: isError ? error : null,
        transportations: data?.data || data?.transportations || [],
        meta: data?.data?.meta || null,
    };
};

export default useGetTransportations;
